module.exports = __webpack_public_path__ + "media/assets/icons/earningrate-8b315bf2cc20ecb8d6b6fe992a359a7a.svg";